import React, { FC } from "react";

const TabContainer: FC = ({ children }) => (
  <div className="fixed bottom-0 left-0 right-0 z-50 pb-16 overflow-auto bg-white top-13 sm:static">
    {children}
  </div>
);

export default TabContainer;
